<div *ngIf="PartialViewReady">
    <div *ngIf="ShowSummerRolloverNote">
        <strong>School year note: </strong><em>The current Polk County Public Schools school year has not yet been updated in the district student information system. Requests for upcoming Fall Term college or university semesters <strong><u>are not affected</u></strong> by this and Fall Term requests <strong><u>can</u></strong> be processed through the DELTA System by using the provided tools at this time. Please ensure that a "Fall Term" is selected in the term selection box when working on these requests.</em>
    </div>
    <!-- TODO: Refactor into component -->
    <h2>Current Notifications</h2>
    <div *ngIf="User && (User.IsParent || User.IsStudent || User.IsAdvisor || User.IsCollegeAdmin || User.IsCollegeSupport)">
        <div *ngIf="LastLogin != null" style="margin-bottom:1rem">You last logged in to the DELTA System on {{LastLogin | date:'MMM. d, yyyy'}} ({{LastLogin | date:'h:mm a'}}).</div>
        <div *ngIf="CurrentNotifications && CurrentNotifications.length" fxLayout="column" fxLayoutAlign="start stretch">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px" *ngFor="let item of CurrentNotifications">
                <mat-icon>{{item.IconName || 'notifications'}}</mat-icon>
                <div>{{item.Message}}</div>
                <button type="button" *ngIf="item.Details && item.Details.length" mat-button color="primary" (click)="ShowNotificationDetails(item)">More...</button>
            </div>
        </div>
        <div *ngIf="!(CurrentNotifications && CurrentNotifications.length)">There are no new notifications available at this time.</div>
        <div fxHide.gt-sm>
            <hr />
            <div style="margin-top:30px">
                To access the DELTA navigation menu, click or tap on the <mat-icon>menu</mat-icon> icon in the upper-left corner of the application screen.
            </div>
        </div>
    </div>
    <div *ngIf="User && !User.IsParent && !User.IsStudent && !User.IsAdvisor && !User.IsCollegeAdmin && !User.IsCollegeSupport">
        <span>Welcome {{User.FirstName | titleCase}} {{User.LastName | titleCase}}. </span>
        <span *ngIf="LastLogin != null" style="margin-bottom:1rem">You last logged in to the DELTA System on {{LastLogin | date:'MMM. d, yyyy'}} ({{LastLogin | date:'h:mm a'}}).</span>
        <div class="margintop">
            <span>You have <strong>{{StudentCount}} student(s)</strong> that require your attention.</span>
            <span *ngIf="StudentCount > 0">Please <button mat-button color="primary" (click)="ShowNotificationOverview()">click here</button> to view all students that require action on your part.</span>
        </div>
        <div class="margintop" *ngIf="AdoptionRequests && AdoptionRequests.length && (User.IsDistrictAdmin || User.IsDeveloper)">
            <span>There are adoption requests that require review. Please <button mat-button color="primary" (click)="ShowNotificationOverview(true)">click here</button> to view adoption request notifications.</span>
        </div>
        <!-- This is for guidance so far -->
        <div class="margintop">Click on <span style="text-transform:uppercase">REPORTS</span> to the left to access the current status of all your students.</div>
        <div fxHide fxShow.lt-md>
            To access the DELTA navigation menu, click or tap on the <mat-icon>menu</mat-icon> icon in the upper-left corner of the application screen.
            </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/home/home.component.html